// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"427":"67c8f1a6","457":"f6ad106f"}[chunkId] + ".chunk.js");